import { Button } from '../../../../../ui/index'
import { currentYear, monthsOptions as months } from '../../../../../../utils/constant'
import autoConciliationStep1Art from '../../../../../../../assets/conciliacion-automatica/step1-art.png'
import autoConciliationStep2TopArt from '../../../../../../../assets/conciliacion-automatica/step2-top-art.png'
import autoConciliationStep2BottomArt from '../../../../../../../assets/conciliacion-automatica/step2-bottom-art.png'
import autoConciliationStep3BottomArt from '../../../../../../../assets/conciliacion-automatica/step3-bottom-art.png'

export default function AutomaticConciliationModal({ isUpdatingAutomaticConciliation, isRunningRemunerationConciliation, isRunningTransferConciliation, isRunningF29Conciliation, showAutoConciliationModal, autoConciliationAction, autoConciliationStep, autoConciliationPeriod, autoConciliationMonth, setAutoConciliationPeriod, setAutoConciliationMonth, handleCloseAutoConciliationModal, handlePreviousAutoConciliationStep, handleConfirmAutomaticConciliationModal }) {
  return (<>
        {showAutoConciliationModal && (
          <div role='dialog' aria-modal='true' aria-label='Conciliación automática' className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
            <div
              className='w-[980px] max-w-[96vw] max-h-[90vh] overflow-y-auto rounded-2xl bg-white shadow-2xl'
              onClick={e => e.stopPropagation()}
            >
              <div className='bg-primary px-4 py-3 flex items-center justify-between'>
                <span className='text-white font-semibold text-sm font-sans'></span>
                <button
                  type='button'
                  onClick={handleCloseAutoConciliationModal}
                  disabled={
                    isUpdatingAutomaticConciliation ||
                    isRunningRemunerationConciliation || 
                    isRunningTransferConciliation || 
                    isRunningF29Conciliation
                  }
                  className='text-white hover:bg-white/20 rounded-full p-1 transition-colors disabled:opacity-70'
                  aria-label='Cerrar modal'
                >
                  ✕
                </button>
              </div>

              <div className='px-8 py-6 min-h-[230px] flex flex-col'>
                <h2 className='text-xl md:text-2xl font-sans text-center mb-5 leading-tight'>
                  {autoConciliationAction === 'deactivate'
                    ? 'Desactivar conciliación automática'
                    : autoConciliationStep === 4
                      ? 'Antes de activar: revisión necesaria'
                      : autoConciliationStep === 3
                        ? 'Elegir qué tipo de conciliación quieres'
                        : autoConciliationStep === 2
                          ? '¿Cómo funciona la conciliación automática?'
                          : 'Activa la conciliación automática'}
                </h2>
                {autoConciliationAction === 'deactivate' ? (
                  <div className='text-sm md:text-base font-sans leading-snug text-gray-800 space-y-4'>
                    <p>Se apagará la conciliación automática para esta empresa.</p>
                    <p>
                      Los nuevos movimientos ya no se conciliarán de forma automática y quedarán
                      disponibles para revisión manual.
                    </p>
                  </div>
                ) : autoConciliationStep === 4 ? (
                  <div className='text-sm md:text-base font-sans leading-snug text-gray-800 space-y-4'>
                    <p>
                      Para que la conciliación automática funcione correctamente desde el inicio,
                      revisa estos casos:
                    </p>
                    <section className='rounded-xl bg-gray-100 px-4 py-3 md:flex md:items-center md:gap-4'>
                      <div className='flex-1'>
                        <p className='font-semibold'>
                          1. Pagos de este año que corresponden a documentos del año anterior
                        </p>
                        <p className='mt-1'>
                          Si una factura del año pasado fue pagada este año (o viceversa), debes
                          marcarla manualmente como pagada o cobrada desde el movimiento bancario.
                        </p>
                      </div>
                      <img
                        src={autoConciliationStep2TopArt}
                        alt='Ilustración coincidencia exacta'
                        className='mt-3 md:mt-0 w-full md:w-56 rounded-lg object-contain'
                      />
                    </section>
                    <section className='rounded-xl bg-gray-100 px-4 py-3 md:flex md:items-center md:gap-4'>
                      <div className='flex-1'>
                        <p className='font-semibold'>
                          2. Documentos pagados por anticipado el año anterior
                        </p>
                        <p className='mt-1'>
                          Revisa documentos de clientes o proveedores que hayan sido pagados antes y
                          asegúrate de identificarlos correctamente desde el movimiento bancario.
                        </p>
                      </div>
                      <img
                        src={autoConciliationStep3BottomArt}
                        alt='Ilustración método FIFO'
                        className='mt-3 md:mt-0 w-full md:w-56 rounded-lg object-contain'
                      />
                    </section>
                    <section className='rounded-xl bg-gray-100 px-4 py-3'>
                      <p className='font-semibold'>Por qué es importante:</p>
                      <p className='mt-1'>
                        Si no haces esta revisión, pueden generarse descalces en la conciliación
                        automática.
                      </p>
                    </section>
                  </div>
                ) : autoConciliationStep === 3 ? (
                  <div className='mx-auto flex w-full max-w-2xl flex-col gap-4 text-sm md:text-base font-sans text-gray-800'>
                    <p className='text-center'>
                      Selecciona desde qué fecha quieres comenzar la conciliación automática.
                    </p>
                    <div
                      className='grid gap-3 md:grid-cols-2'
                      role='radiogroup'
                      aria-label='Período de conciliación'
                    >
                      <label
                        className={`cursor-pointer rounded-xl border-2 p-4 transition-colors ${
                          autoConciliationPeriod === 'current-month'
                            ? 'border-accent2 bg-accent2/10'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <div className='flex items-start gap-3'>
                          <input
                            type='radio'
                            name='auto-conciliation-period'
                            value='current-month'
                            checked={autoConciliationPeriod === 'current-month'}
                            onChange={e => setAutoConciliationPeriod(e.target.value)}
                            className='mt-1 h-4 w-4 accent-accent2'
                          />
                          <div>
                            <p className='font-semibold'>Desde el inicio de un mes</p>
                            <p className='mt-1 text-sm text-gray-600'>
                              Conciliar movimientos desde el 1 de{' '}
                              {months.find(month => month.value === autoConciliationMonth)?.label}
                              {' '}de {currentYear}.
                            </p>
                          </div>
                        </div>
                      </label>
                      <label
                        className={`cursor-pointer rounded-xl border-2 p-4 transition-colors ${
                          autoConciliationPeriod === 'current-year'
                            ? 'border-accent2 bg-accent2/10'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <div className='flex items-start gap-3'>
                          <input
                            type='radio'
                            name='auto-conciliation-period'
                            value='current-year'
                            checked={autoConciliationPeriod === 'current-year'}
                            onChange={e => setAutoConciliationPeriod(e.target.value)}
                            className='mt-1 h-4 w-4 accent-accent2'
                          />
                          <div>
                            <p className='font-semibold'>Desde el inicio de este año</p>
                            <p className='mt-1 text-sm text-gray-600'>
                              Conciliar movimientos desde el 1 de enero de {currentYear}.
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>
                    {autoConciliationPeriod === 'current-month' && (
                      <div>
                        <label htmlFor='auto-conciliation-month' className='mb-2 block text-sm font-semibold'>
                          Mes de inicio ({currentYear})
                        </label>
                        <select
                          id='auto-conciliation-month'
                          value={autoConciliationMonth}
                          onChange={event => setAutoConciliationMonth(Number(event.target.value))}
                          className='w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm focus:border-accent2 focus:outline-none focus:ring-1 focus:ring-accent2'
                        >
                          {months.filter(month => month.value >= 1 && month.value <= 12).map(month => (
                            <option key={month.value} value={month.value}>{month.label}</option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                ) : autoConciliationStep === 2 ? (
                  <div className='grid gap-6 md:grid-cols-[1fr_360px] text-sm md:text-base font-sans leading-snug text-gray-800'>
                    <div className='space-y-4'>
                      <p className='font-semibold text-base md:text-lg'>
                        TryLuca concilia tu información en dos etapas:
                      </p>
                      <section className='space-y-1'>
                        <p className='font-semibold text-base'>
                          1. Coincidencia exacta (prioridad alta)
                        </p>
                        <ul className='list-none pl-0 space-y-1'>
                          <li className='flex items-center gap-2'>
                            <span className='text-green-600 font-bold'>✓</span>
                            <span className='font-semibold'>Razón social</span>
                          </li>
                          <li className='flex items-center gap-2'>
                            <span className='text-green-600 font-bold'>✓</span>
                            <span className='font-semibold'>RUT</span>
                          </li>
                          <li className='flex items-center gap-2'>
                            <span className='text-green-600 font-bold'>✓</span>
                            <span className='font-semibold'>Monto</span>
                          </li>
                          <li className='flex items-center gap-2'>
                            <span className='text-green-600 font-bold'>✓</span>
                            <span className='font-semibold'>Fecha aproximada</span>
                          </li>
                        </ul>
                      </section>
                      <section className='space-y-1'>
                        <p className='font-semibold text-base'>
                          2. Método FIFO (respaldo automático)
                        </p>
                        <p>Si no hay coincidencia exacta, se aplica lógica FIFO.</p>
                        <p className='font-medium'>
                          Los pagos más antiguos se asignan a las facturas pendientes más antiguas.
                        </p>
                        <p>
                          Así se logra conciliar incluso cuando los{' '}
                          <span className='font-semibold'>datos no coinciden</span> perfectamente.
                        </p>
                      </section>
                    </div>
                    <div className='space-y-3'>
                      <img
                        src={autoConciliationStep2TopArt}
                        alt='Ilustración coincidencia exacta'
                        className='w-full rounded-lg object-contain'
                      />
                      <img
                        src={autoConciliationStep2BottomArt}
                        alt='Ilustración método FIFO'
                        className='w-full rounded-lg object-contain'
                      />
                    </div>
                  </div>
                ) : (
                  <div className='text-sm md:text-base font-sans leading-snug text-gray-800 space-y-4'>
                    <img
                      src={autoConciliationStep1Art}
                      alt='Ilustración conciliación automática'
                      className='mx-auto w-full max-w-[500px] rounded-lg object-contain'
                    />
                    <p>
                      Al activar esta opción,{' '}
                      <span className='font-semibold'>
                        TryLuca conciliará automáticamente tus movimientos bancarios.
                      </span>
                    </p>
                    <p>
                      Compara documentos del SII con movimientos del banco para{' '}
                      <span className='font-semibold'>identificar pagos y cobros</span>, reduciendo
                      el trabajo manual.
                    </p>
                    <p>
                      <span className='font-semibold'>
                        Mientras antes lo actives correctamente, más automático será todo en
                        adelante.
                      </span>
                    </p>
                  </div>
                )}
              </div>
              {(isRunningRemunerationConciliation ||
                isRunningTransferConciliation ||
                isRunningF29Conciliation ||
                isUpdatingAutomaticConciliation) && (
                <div className='border-t bg-gray-50 px-6 py-3 text-center'>
                  <span className='text-sm font-sans text-gray-600'>
                    {isUpdatingAutomaticConciliation
                      ? 'Activando la conciliación automática...'
                      : 'Resolviendo conciliaciones, esto puede tardar unos momentos...'}
                  </span>
                </div>
              )}
              <div className='border-t px-6 py-4 flex justify-end gap-3 bg-gray-50'>
                {autoConciliationAction === 'activate' && autoConciliationStep > 1 && (
                  <Button
                    onClick={handlePreviousAutoConciliationStep}
                    disabled={
                      isUpdatingAutomaticConciliation ||
                      isRunningRemunerationConciliation ||
                      isRunningTransferConciliation || 
                      isRunningF29Conciliation
                    }
                    className='text-sm border border-gray-300 bg-primary text-white rounded-full px-5 font-sans'
                    title='Volver'
                  />
                )}
                <Button
                  onClick={handleConfirmAutomaticConciliationModal}
                  disabled={
                    isUpdatingAutomaticConciliation ||
                    isRunningRemunerationConciliation || 
                    isRunningTransferConciliation || 
                    isRunningF29Conciliation
                  }
                  className='text-sm bg-accent2 text-white rounded-full px-5 font-sans'
                  title={
                    isRunningRemunerationConciliation ||
                    isRunningTransferConciliation ||
                    isRunningF29Conciliation
                      ? 'Resolviendo conciliaciones...'
                      : isUpdatingAutomaticConciliation
                        ? 'Activando conciliación automática...'
                        : autoConciliationAction === 'deactivate'
                          ? 'Desactivar conciliación automática'
                          : autoConciliationStep === 1
                            ? 'Continuar'
                            : autoConciliationStep === 2
                              ? 'Entendido'
                              : autoConciliationStep === 3
                                ? 'Continuar'
                                : 'Activar conciliación automática'
                  }
                />
              </div>
            </div>
          </div>
        )}

  </>)
}
